import Vue from 'vue'
import Router from 'vue-router'
import StrongEdition from '@/pages/StrongEdition'
import Classics from '@/pages/Classics'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/Classics'
    },
    {
      path: '/Classics',
      component: Classics,
      meta: {
        title: '经典版'
      }
    },
    {
      path: '/FeatureIntroduce',
      component: () => import('@/pages/Classics/FeatureIntroduce'),
      meta: {
        title: '功能介绍'
      }
    },
    {
      path: '/PermissionIntroduce',
      component: () => import('@/pages/Classics/PermissionIntroduce'),
      meta: {
        title: '应用涉及权限'
      }
    },
    {
      path: '/StrongEdition',
      component: StrongEdition,
      meta: {
        title: '加强版'
      }
    },
    {
      path: '/EmMobile',
      redirect: '/Classics'
    }
  ]
})

// 使用afterEach钩子函数，保证路由跳转成功之后修改title
router.afterEach(route => {
  let documentTitle = ''

  route.matched.forEach(path => {
    if (path.meta.title) {
      documentTitle = path.meta.title
    }
  })

  if (documentTitle) {
    document.title = documentTitle
    // 直接修改title，ios设备不能自动刷新，需要调用客户端的方法进行更新
    if (window.goods && window.goods.updateTitle) {
      window.goods.updateTitle({ title: documentTitle })
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js